.container {
  display: flex;
  width: 100%;
}

.tab {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 41px;
  border: 1px solid #e6e6e6;
  transition: box-shadow 0.3s ease;
}
.tab:hover {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.active {
  background-color: white;
  transition: box-shadow 0.3s ease;
}

.active p {
  border-bottom: 2px solid black;
}
